"use strict";
/* eslint-disable camelcase */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockUserSettings = exports.mockAccountData = exports.mockSuccessfulResponse = void 0;
exports.mockSuccessfulResponse = {
    success: true,
    errors: null,
};
exports.mockAccountData = {
    account_data: {
        nickname: 'User',
        full_name: null,
        is_sso: true,
        email: 'user@test.com',
        profile_picture_url: 'https://picsum.photos/200?random=1',
        locale: 'en',
        primary_course_display_name: 'Java',
        email_notifications_enabled: true,
        subscribe_to_notification_emails: true,
        subscribe_to_progress_emails: true,
        primary_course_update_enabled: true,
        primary_course: '32746y9ewdswakdasd',
        courses_list: [
            { uuid: '32746y9ewdswakdasd', display_name: 'Java' },
            { uuid: '32746y9ewdswak3245', display_name: '.Net' },
            { uuid: '32746y9ewdswa34rfd', display_name: 'React' },
        ],
        login_integration: null,
    },
};
exports.mockUserSettings = {
    user_settings: {
        display_leaderboard: true,
        display_phase_two: true,
    },
};
